import { render, staticRenderFns } from "./MediaSet.vue?vue&type=template&id=4718871e&scoped=true&"
import script from "./MediaSet.vue?vue&type=script&lang=js&"
export * from "./MediaSet.vue?vue&type=script&lang=js&"
import style0 from "./MediaSet.vue?vue&type=style&index=0&id=4718871e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718871e",
  null
  
)

export default component.exports